import R from 'ramda';

import { getAnswers, postAnswer } from '_api/answers';

import { upsertSurveyAnswer, setSurveyAnswers } from '_actions/answers';

import { dispatchError } from '_utils/api';

export const attemptGetSurveyAnswers = id => dispatch =>
  getAnswers(id)
    .then(data => {
      const answers = data.answers.map(a => { return { sID: id, qID: a.question_id, answer: a.value, encrypted_field: a.encrypted_field ?? false } });

      dispatch(setSurveyAnswers(id, answers));

      return answers;
    })
    .catch(dispatchError(dispatch));

//TODO: maybe make async?
export const attemptUpsertAnswers = (info) => dispatch => 
  postAnswer(info)
    .then(data => {
      const answers = data.answers;

      for (const a in answers) {
        dispatch(upsertSurveyAnswer({
          sID: answers[a][0],
          qID: answers[a][1],
          answer: answers[a][2],
          encrypted_field: answers[a][3]
        }));
      }

      return answers; //TODO: check in on this
    })
    .catch(dispatchError(dispatch));